import { ContactDto } from '@/api/generated';
import { useViewWrapperNewContext } from '@/components/viewWrapperNew/context/ViewWrapperNew.context.ts';

export const useContactDetailsWrapperContext = () => {
  return useViewWrapperNewContext<ContactDto>();
};
